import { useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { useBreadcrumb, BreadcrumbProvider, AuthController } from "$components";
import * as Page from "$containers";
import { storage } from "$hooks/usePersistedState";

function Router() {
  const { links } = useBreadcrumb();

  useEffect(() => {
    storage.clear();
  }, []);

  return (
    <BrowserRouter>
      <AuthController />
      <Switch>
        {/* Public routes */}
        <Route
          path="/"
          exact
          render={() => {
            const user = localStorage.getItem("authState");
            if (!user || !JSON.parse(user)?.user) return <Page.Connexion />;
            return <Page.Projects />;
          }}
        />
        <Route path="/mot-de-passe" exact component={Page.Recovery} />
        <Route path="/succes" exact component={Page.Succes} />
        <Route
          path="/connexion"
          exact
          render={() => {
            const user = localStorage.getItem("authState");
            if (!user || !JSON.parse(user)?.user) return <Page.Connexion />;
            return <Page.Projects />;
          }}
        />
        <Route
          path="/dossier-expedition/:id"
          exact
          render={() => <Page.ShippingPublic />}
        />

        {/* Private routes */}
        {links &&
          links.map(({ path, component: Component, hasAccess }, key) => (
            <Route
              exact
              path={path}
              // eslint-disable-next-line react/no-array-index-key
              key={key}
              render={(props: any) => {
                const user = localStorage.getItem("authState");
                if (!hasAccess) {
                  return <Page.Forbidden />;
                }
                return (
                  <BreadcrumbProvider routerProps={props}>
                    {!user || !JSON.parse(user)?.user ? (
                      <Page.Connexion />
                    ) : (
                      <Component {...props} />
                    )}
                  </BreadcrumbProvider>
                );
              }}
            />
          ))}
      </Switch>
    </BrowserRouter>
  );
}

export default Router;
